var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.70711 8.20711C9.09763 7.81658 9.09763 7.18342 8.70711 6.79289L2.34315 0.428932C1.95262 0.0384078 1.31946 0.0384078 0.928932 0.428932C0.538408 0.819457 0.538408 1.45262 0.928932 1.84315L6.58579 7.5L0.928932 13.1569C0.538408 13.5474 0.538408 14.1805 0.928932 14.5711C1.31946 14.9616 1.95262 14.9616 2.34315 14.5711L8.70711 8.20711ZM7 7.5V8.5H8V7.5V6.5H7V7.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNext);
export default __webpack_public_path__ + "static/media/arrowNext.808b9904.svg";
export { ForwardRef as ReactComponent };